var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('HomeHeader')],1),_c('router-view'),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path=='/'),expression:"$route.path=='/'"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }